import { FC } from 'react';
import { HilabTheme } from '@PeD/hilib'

import 'config/i18n'
import { AppContext } from 'contexts/AppContext'
import Switcher from 'components/main/Switcher'
import './App.css'

const App: FC = (): JSX.Element => {
  return (
    <AppContext>
      <HilabTheme>
        <Switcher />
      </HilabTheme>
    </AppContext>
  );
}

export default App;
